import * as mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';
import { state } from './state';

export default {
  state,
  mutations,
  actions,
  getters,
};
